module.exports = __webpack_public_path__ + "src/assets/games/10/385.jpg";